import { ComponentType, SVGProps } from 'react';
import ApplicationsIcon from 'assets/ApplicationsIcon';
import WorkOrdersIcon from 'assets/WorkOrdersIcon';
import { RecordType } from './types';

interface RecordTypeVisual {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
  variantClassName: string;
}

/**
 * Visual descriptor for each known record type. To support a new downstream
 * record type, add an entry here (and extend `RecordType`) — the indicator
 * component and callers pick it up without further changes.
 */
export const RECORD_TYPE_INDICATORS: Record<RecordType, RecordTypeVisual> = {
  WORK_ORDER: {
    icon: WorkOrdersIcon,
    label: 'Work Orders created',
    variantClassName: 'records-created-indicator--work-order'
  },
  APPLICATION: {
    icon: ApplicationsIcon,
    label: 'Applications created',
    variantClassName: 'records-created-indicator--application'
  }
};

/** Fixed display order (amber Work Order first, then blue Application). */
export const RECORD_TYPE_ORDER: RecordType[] = ['WORK_ORDER', 'APPLICATION'];
